import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

const utcToMySql = () => dayjs.utc().format("YYYY-MM-DD HH:mm:ss")

export default utcToMySql